import { RiskLevel } from '@/gen/inventory/v1/risk_pb'

export const SEVERITY_ORDER = {
  [RiskLevel.CRITICAL]: 0,
  [RiskLevel.HIGH]: 1,
  [RiskLevel.MEDIUM]: 2,
  [RiskLevel.LOW]: 3,
} as Record<RiskLevel, number>

export const FALLBACK_SEVERITY_ORDER = 999
